export default function PHP_thread_safe() {
  return (
    <div>
      <h1>PHP_thread_safe</h1>
    </div>
  );
}
